// tslint:disable

import { Map } from 'immutable';
import { Subject } from 'rxjs/Subject';
import { Field } from './form.lib';

export class ConsoleLib {
    private query: Map<string, any> = Map({}).asMutable();
    private onQuery$: Subject<any>;

    constructor(consoleConfig: any) {
        this.onQuery$ = consoleConfig.onQuery$;
    }

    public setQuery(property: string, fieldDef: any, transform?: (v: any) => any) {
        const field = new Field(Object.assign(fieldDef, {property}));
        field.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.subscribe((value: any) => {
            if (value || value[0]) {
                this.query.set(property, transform ? transform(value[0]) : value[0]);
            }
            if (!value) {
                this.query.remove(property);
            }
            if (value[0] === false && value[1] === false) {
                this.query.remove(property);
            }
            this.onQuery$.next(this.query.toJS());
        });
        return field;
    }

    public setQueryByObj(property: string, fieldDef: any, transform?: (v: any) => any) {
        const field = new Field(Object.assign(fieldDef, {property}));
        field.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.subscribe((value: any) => {

            if (!value[0]) {
                return;
            }

            Object.keys(this.query.toObject()).forEach((key: string) => {
                if ((new RegExp(`^${property}`)).test(key)) {
                    this.query.remove(key);
                }
            });

            if (value || value[0] || value[0].value) {
                this.query.set(`${property}[${value[0].value.kValue}]`, value[0].value.vValue);
            }

            this.onQuery$.next(this.query.toJS());
        });
        return field;
    }

    public setQueryWithProp(property: string, fieldDef: any, transform?: (v: any) => any) {
        const field = new Field(Object.assign(fieldDef, {property}));

        field.onValueChanges$.subscribe((value: any) => {

            this.query.removeIn([property]);

            if (value) {
                this.query.set(`${property}[${value.keyValue}]`, value.value);
            }

            this.onQuery$.next(this.query.toJS());
        });

        return field;
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/console.lib.tsx